import { gql } from '@apollo/client';

// eslint-disable-line import/no-extraneous-dependencies
export const CHECK_SESSION = gql`
  mutation CheckSession {
    checkSession
  }
`;
